export default __webpack_public_path__ + "media/images/images_v2/bande-white-64ed386702b5e3c31f068a1d03706175.png";